// TODO: code clean-up needed
import React, { useEffect, useRef, useState } from 'react';
import { cloneDeep, isEmpty } from 'lodash';
import {
   array,
   arrayOf,
   bool,
   element,
   func,
   number,
   object,
   shape,
   string,
} from 'prop-types';
import {
   Bar,
   BarChart,
   Brush,
   CartesianGrid,
   Cell,
   LabelList,
   Legend,
   ResponsiveContainer,
   Tooltip,
   XAxis,
   YAxis,
} from 'recharts';
import { DateUtil } from '../../../utils/date-util.js';
import { BRUSH_STROKES } from '../chart-colors.js';
import { BRUSH_INITIAL_DATA_LENGTH } from '../chart-util.js';
import {
   getBarCellBackgroundFill,
   getBarCellFill,
   getBarChartStackedGroupedConfig,
} from './bar-chart-stacked-grouped-wrapper-util.js';

export const CustomizedGroupXAxisTick = (props) => {
   const { x, y, payload } = props;
   let rotation = 'rotate(0)';
   let textX = 0;
   if (props.visibleTicksCount > Math.ceil(BRUSH_INITIAL_DATA_LENGTH * 1.5)) {
      rotation = 'rotate(-90)';
      textX = payload.value.length > 3 ? -40 : -15;
   }
   const pathX = Math.floor(x + payload.offset);

   const path = <path d={`M${pathX},${y}v${-38}`} stroke='gray' />;

   return (
      <>
         {path}
         <g transform={`translate(${x},${y})`}>
            <text
               x={textX}
               y={0}
               dy={16}
               textAnchor='middle'
               fill='#666'
               transform={rotation}
            >
               {payload.value}
            </text>
         </g>
      </>
   );
};

const BarChartStackedGroupedWrapper = ({ chartData, configChart }) => {
   const [data, setData] = useState([chartData]);

   const {
      chartWidth,
      chartHeight,
      plotBars,
      getBarKeys,
      getGroupBarKeys,
      isHighLightBarOnClick,
      isHighLightCellOnClick,
      isStackedBars,
      stackedValues,
      barSize,
      barStrokes,
      isBarRoundedEdge,
      barBackgroundColor,
      barOnClickHandler,
      xGroupAxisKey,
      xGroupAxisTickFormatter,
      xGroupAxisTick,
      xGroupAxisHeight,
      xGroupAxisTickMargin,
      yAxisTickFormatter,
      legendLabels,
      legendIcon,
      isGroupLegend,
      legendTextColor,
      isToggleChartOnClickOfLegend,
      isVisibleHorizontalGrid,
      tooltipContent,
      brush,
      getBarEdge,
   } = getBarChartStackedGroupedConfig(configChart, data || []);

   const [displayedBarKeys, setDisplayedBarKeys] = useState(
      isGroupLegend ? getGroupBarKeys(stackedValues) : getBarKeys(plotBars)
   );
   const [selectedBarKey, setSelectedBarKey] = useState({});

   const renderCustomizedLabel = (props, generatedBarKey, chartHeight) => {
      const fixOffset = 10;

      return (
         <g>
            <text
               x={props.x + barSize / 2}
               y={
                  chartHeight -
                  xGroupAxisHeight -
                  xGroupAxisTickMargin -
                  (brush.brushHeight || 0) -
                  fixOffset
               }
               fill='#000'
               textAnchor='middle'
               dominantBaseline='middle'
            >
               {generatedBarKey.slice(-1)}
            </text>
         </g>
      );
   };

   let barIterateIndex = 0;

   const barEdgeStyle = getBarEdge(displayedBarKeys, isBarRoundedEdge);
   const barCellFillStyle = getBarCellFill(
      selectedBarKey,
      isHighLightBarOnClick,
      isHighLightCellOnClick
   );
   const barBackgroundFillStyle = getBarCellBackgroundFill(
      isStackedBars,
      barBackgroundColor,
      barEdgeStyle
   );

   const handleOnClickBarOrCell = (clickedItemData) => {
      isEmpty(selectedBarKey) ||
      (!isHighLightCellOnClick && !isHighLightBarOnClick) ||
      (isHighLightCellOnClick &&
         selectedBarKey.cellId !== clickedItemData.cellId) ||
      (!isHighLightCellOnClick &&
         isHighLightBarOnClick &&
         selectedBarKey.cellIndex !== clickedItemData.cellIndex)
         ? setSelectedBarKey(clickedItemData)
         : setSelectedBarKey({});
   };

   const handleOnClickLegendItem = (groupDataKey) => {
      const foundAt = displayedBarKeys.indexOf(groupDataKey);
      const copyOfDataKeys = cloneDeep(displayedBarKeys);
      foundAt === -1
         ? copyOfDataKeys.push(groupDataKey)
         : copyOfDataKeys.splice(foundAt, 1);
      setDisplayedBarKeys(copyOfDataKeys);
   };

   const renderLegend = (barStrokes) => {
      return (
         <div className='custom-legend-container'>
            {stackedValues.map((groupDataKey, colorIndex) => {
               const onClickHandler = () =>
                  handleOnClickLegendItem(groupDataKey);
               const isOmit = displayedBarKeys.indexOf(groupDataKey) === -1;
               const omittedCss = isOmit ? ' custom-legend-list--removed' : '';
               return (
                  <>
                     <span
                        key={`item-icon-${colorIndex}`}
                        onClick={onClickHandler}
                        className='custom-legend-list--icon'
                        style={{
                           backgroundColor: isOmit
                              ? '#cccccc'
                              : barStrokes[colorIndex],
                        }}
                     ></span>
                     <span
                        key={`item-text-${colorIndex}`}
                        onClick={onClickHandler}
                        className={`custom-legend-list--text${omittedCss}`}
                     >
                        {groupDataKey}
                     </span>
                  </>
               );
            })}
         </div>
      );
   };

   const isShowLegend = (data, pBars) => !(isEmpty(data) || isEmpty(pBars));

   useEffect(
      () => barOnClickHandler && barOnClickHandler(selectedBarKey),
      [
         // barOnClickHandler,
         selectedBarKey,
      ]
   );

   useEffect(() => {
      setData(chartData);
   }, [chartData]);

   useEffect(() => {
      setDisplayedBarKeys(stackedValues);
   }, [stackedValues]);

   return isEmpty(data) || isEmpty(plotBars) ? (
      <div style={{ height: '20rem' }}>
         <h4 className='no-records-found'>No Records Found</h4>
      </div>
   ) : (
      <ResponsiveContainer
         width={chartWidth}
         height={chartHeight}
         debounce={1}
         key={DateUtil.getNowMoment()} //TODO: to implement in a better way
      >
         <BarChart
            stackOffset='sign'
            // barGap={100}
            // barCategoryGap={30}
            width={500}
            height={chartHeight}
            data={data}
            margin={{
               top: 5,
               right: 30,
               left: 20,
               bottom: 5,
            }}
         >
            {isVisibleHorizontalGrid && <CartesianGrid vertical={false} />}
            <XAxis
               type='category'
               dataKey={xGroupAxisKey}
               height={xGroupAxisHeight}
               tickMargin={xGroupAxisTickMargin}
               tickLine={false}
               tick={<CustomizedGroupXAxisTick />}
            />

            <YAxis />

            {tooltipContent ? (
               <Tooltip content={tooltipContent} />
            ) : (
               <Tooltip />
            )}

            {!isEmpty(chartData) && !isEmpty(brush) && (
               <Brush
                  height={brush.brushHeight}
                  dataKey={xGroupAxisKey}
                  startIndex={brush.startIndex}
                  endIndex={brush.endIndex}
                  stroke={BRUSH_STROKES[0]}
                  tickFormatter={brush.tickFormatter}
               />
            )}

            {isShowLegend(data, plotBars) ? (
               isGroupLegend ? (
                  <Legend content={() => renderLegend(barStrokes)} />
               ) : (
                  <Legend />
               )
            ) : null}

            {!isEmpty(chartData) &&
               !isEmpty(displayedBarKeys) &&
               plotBars.map((barKey, barIndex) => {
                  const groupKey = barKey.slice(-2);
                  const colorIndex = stackedValues.indexOf(groupKey);
                  const barRadius = barEdgeStyle(barIterateIndex);
                  const background = barBackgroundFillStyle(barIterateIndex);
                  barIterateIndex =
                     colorIndex === -1 ? barIterateIndex : barIterateIndex + 1;
                  const isHideBar = displayedBarKeys.indexOf(groupKey) === -1;
                  const generatedBarKey = barKey.slice(0, -3);

                  return (
                     <Bar
                        background={background}
                        radius={barRadius}
                        hide={isHideBar}
                        key={`bars_${barIndex}`}
                        dataKey={barKey}
                        stackId={generatedBarKey.slice(-1)}
                        barSize={barSize}
                        onClick={
                           barOnClickHandler &&
                           ((pickedData) => handleOnClickBarOrCell(pickedData))
                        }
                        fill={barStrokes[colorIndex]}
                     >
                        <LabelList
                           content={(props) =>
                              renderCustomizedLabel(
                                 props,
                                 generatedBarKey,
                                 chartHeight
                              )
                           }
                        />

                        {!isEmpty(chartData) &&
                           chartData.map((entry, cellIndex) => {
                              const cIndex = `bar-${cellIndex}`;
                              const cId = `cell-${barKey}-${cellIndex}`;
                              return (
                                 <Cell
                                    key={cId}
                                    cellIndex={cIndex}
                                    cellId={cId}
                                    cursor='pointer'
                                    fill={barCellFillStyle(
                                       cIndex,
                                       cId,
                                       barStrokes[colorIndex]
                                    )}
                                    strokeWidth={4}
                                 />
                              );
                           })}
                     </Bar>
                  );
               })}
         </BarChart>
      </ResponsiveContainer>
   );
};

BarChartStackedGroupedWrapper.propTypes = {
   chartData: array.isRequired,
   configChart: shape({
      chartTitle: string.isRequired,
      chartWidth: number,
      chartHeight: number,
      configBars: shape({
         plotBars: arrayOf(string).isRequired,
         isHighLightBarOnClick: bool,
         isHighLightCellOnClick: bool,
         isStackedBars: bool,
         barSize: number,
         barStrokes: object,
         isBarRoundedEdge: bool,
         isSetBarBackground: bool,
         barBackgroundColor: string,
         barOnClickHandler: func,
      }).isRequired,
      configXAxis: shape({
         xAxisKey: string.isRequired,
         xAxisTickFormatter: func,
      }).isRequired,
      configYAxis: shape({
         yAxisTickFormatter: func,
      }),
      chartFilters: element,
      configToggle: shape(
         {
            toggleName: string.isRequired,
            className: string,
            toggle: arrayOf(
               shape({
                  toggleLabel: string.isRequired,
                  toggleValue: string.isRequired,
                  className: string,
               })
            ).isRequired,
         }.isRequired
      ),
      configLegends: shape({
         legendLabels: object,
         isToggleChartOnClickOfLegend: bool,
         legendIcon: string,
         isLegendTextColorSameAsChartColor: bool,
      }),
      isVisibleHorizontalGrid: bool,
      tooltipContent: element,
   }),
   apiErrorMessage: object,
   toolbarConfig: shape({
      isShowToolbar: bool,
      refreshIconOnClickHandler: func,
      barChartIconOnClickHandler: func,
      gridChartIconOnClickHandler: func,
   }),
};

export default BarChartStackedGroupedWrapper;
